/* eslint-disable import/prefer-default-export */
import { TFunction } from "i18n";
import { FieldNames } from "../components/BillingAddressFormBlock/constants";
import { RecurlyError } from "../config/common";

type CheckForRecurlyPostCodeError = {
  error: any;
  formikSetFieldError: (field: string, error: string | undefined) => void;
  t: TFunction;
};

export const checkForRecurlyPostCodeError = (
  error: CheckForRecurlyPostCodeError["error"],
  formikSetFieldError: CheckForRecurlyPostCodeError["formikSetFieldError"],
  t: CheckForRecurlyPostCodeError["t"]
): boolean => {
  if (error?.cause) {
    const postalCodeError = (
      error.cause as RecurlyError
    ).RecurlyError.params.find(({ param }) => param === "address.postal_code");

    if (postalCodeError) {
      formikSetFieldError(
        FieldNames.AccountPostalCode,
        t("common:validation.error.entryNotValid", {
          fieldName: t("common:label.zipPostCode"),
        })
      );

      return true;
    }
  }

  return false;
};
